import { login, webLogin, logout, getInfo, webLoginCode, getWebInfo } from '@/api/login'
import { getToken, setToken, removeToken, setWebToken, removeWebToken } from '@/utils/auth'
import Cookies from 'js-cookie'
const WebTokenKey = 'Web-Token'
const user = {
  state: {
    token: getToken(),
    name: '',
    pkUser: null,
    avatar: '',
    roles: [],
    /** 用户当前权限 */
    permissions: [],
    /** 用户当前权限按钮属性集合 */
    functions: [],
    /** 用户当前职责(ROLE&USER使用) */
    pkPost: null,
    /** 用户当前角色(ROLE&POST使用) */
    pkRole: null,
    /** 区分超级管理员 */
    admin: false,
    // /** 用户职责列表 */
    // userPost: localStorage.getItem('userPost') || '[]'
    /** 当前用户职责列表 */
    currentUserPost: localStorage.getItem('currentUserPost') || ''
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      Cookies.set(WebTokenKey, token)
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PK_USER: (state, pkUser) => {
      state.pkUser = pkUser
    },
    SET_REAL_NAME: (state, realName) => {
      state.realName = realName
    },
    SET_AVATAR: (state, avatar) => {
      avatar = !avatar ? '' : avatar;
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_FUNCTIONS: (state, functions) => {
      state.functions = functions
    },
    SET_PK_POST: (state, pkPost) => {
      state.pkPost = pkPost;
    },
    SET_PK_ROLE: (state, pkRole) => {
      state.pkRole = pkRole;
    },
    SET_ADMIN: (state, admin) => {
      state.admin = admin;
    },
    // SET_USER_POST: (state, userPost) => {
    //   state.userPost = JSON.stringify(userPost);
    //   localStorage.setItem('userPost', JSON.stringify(userPost))
    // },
    SET_CUREENT_USER_POST: (state, currentUserPost) => {
      state.currentUserPost = currentUserPost;
      localStorage.setItem('currentUserPost', currentUserPost)
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      const uuid = userInfo.uuid
      return new Promise((resolve, reject) => {
        login(username, password, code, uuid).then(res => {
          let data = res;
          removeWebToken();
          setToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          localStorage.setItem('userName', username);
          localStorage.setItem("loginUser", '');
          localStorage.setItem("openType", "system");
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 网站登录
    WebLogin({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const password = userInfo.password
      const code = userInfo.code
      return new Promise((resolve, reject) => {
        webLogin(username, password, code).then(res => {
          let data = res;
          removeToken();
          setWebToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 网站登录
    WebLoginCode({ commit }, userInfo) {
      const username = userInfo.username.trim()
      const code = userInfo.code
      return new Promise((resolve, reject) => {
        webLoginCode(username, code).then(res => {
          let data = res;
          removeToken();
          setWebToken(data.access_token)
          commit('SET_TOKEN', data.access_token)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          const user = res.user;
          if (res.roles && res.roles.length > 0) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles);
            commit('SET_PERMISSIONS', res.permissions);
            commit('SET_FUNCTIONS', res.functions);
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT']);
          }
          commit('SET_NAME', user.userName);
          commit('SET_PK_USER', user.pkUser);
          commit('SET_PK_POST', user.pkPost);
          commit('SET_PK_ROLE', user.pkRole);
          commit('SET_AVATAR', user.avatar);
          commit('SET_ADMIN', user.admin);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 获取网站用户信息
    GetWebInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getWebInfo().then(res => {
          const user = res.user;
          commit('SET_NAME', user.userName);
          commit('SET_PK_USER', user.pkUser);
          commit('SET_REAL_NAME', user.realName);
          commit('SET_AVATAR', user.avatar);
          localStorage.setItem('userName',user.userName);
          localStorage.setItem('pkUser',user.pkUser);
          localStorage.setItem('realName',user.realName);
          resolve(res);
        }).catch(error => {
          reject(error);
        })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeToken();
          removeWebToken();
          localStorage.setItem('userName','');
          localStorage.setItem('loginUser','');
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 退出系统
/*    LogOutWeb({ commit, state }) {
      return new Promise((resolve, reject) => {
        logoutWeb(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_PERMISSIONS', [])
          removeWebToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },*/

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user
